module.exports = __webpack_public_path__ + "static/img/training_system_s3_max2.73c83e77.png";